import styled from "styled-components";

export const TableWrapper = styled.div`
  width: 50%;
`;
